import React from "react";
import '../styles/versionLoading.css';

const VersionLoading = () => {
    return (
        <>
            <div className="loader-container" >
                <div className="spinner"></div>
            </div>
        </>
    )
}

export default VersionLoading;
